import { VERSION_1 } from '@/libs/constants/b2bApiEndpoints'
import environment from '@/environments/environment.dev'

import HttpClient from './apiHttpClient'

interface ExportShoppingCart {
  sessionId: string
}

interface ReportService {
  exportShoppingCart: ({ sessionId }: ExportShoppingCart) => Promise<unknown>
}

const apiClient = new HttpClient(environment.shopFAPIUrl)
const FAPI_REPORT_ENDPOINT = `/${VERSION_1}/report`

export const reportService: ReportService = {
  async exportShoppingCart({ sessionId }: ExportShoppingCart) {
    const url = `${FAPI_REPORT_ENDPOINT}/summary`

    return apiClient.get(url, {
      params: {
        sessionId,
      },
    })
  },
}
